import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";

import FormData from "form-data";

import axios from "axios";

function AdharOCR() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    "item.details.aadhaar.ismasked": "",
    "item.details.aadhaar.masked_value": "frfrf",
    "item.details.aadhaar.qrstatus":"",
    "item.details.aadhaar.value": "",
    "item.details.dob": "",
    "item.details.name.value": "",
    "item.details.gender.value": "",
    "item.details.address.care_of": "",
    "item.details.address.city": "",
    "item.details.address.district": "",
    "item.details.address.house_number": "",
    "item.details.address.landmark": "",
    "item.details.address.line1": "",
    "item.details.address.line2": "",
    "item.details.address.pin": "",
    "item.details.address.state": "",
    "item.details.face.faceString": "",
    "item.details.husband.value": "",
    "item.details.father.value": "",
    "item.details.daughter_of.value": "",
   
    
  });
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)

  useEffect(() => {
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      "item.details.aadhaar.ismasked": "",
      "item.details.aadhaar.masked_value": "frfrf",
      "item.details.aadhaar.qrstatus":"",
      "item.details.aadhaar.value": "",
      "item.details.dob": "",
      "item.details.name.value": "",
      "item.details.gender.value": "",
      "item.details.address.care_of": "",
      "item.details.address.city": "",
      "item.details.address.district": "",
      "item.details.address.house_number": "",
      "item.details.address.landmark": "",
      "item.details.address.line1": "",
      "item.details.address.line2": "",
      "item.details.address.pin": "",
      "item.details.address.state": "",
      "item.details.face.faceString": "",
      "item.details.husband.value": "",
      "item.details.father.value": "",
      "item.details.daughter_of.value": "",
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://pwkmxo0g2d.execute-api.ap-south-1.amazonaws.com/default/aadharocrservice",
      headers: {
        "x-api-key": "jCSIISHVNG2e3QLKbX0P82l6LyFM4oLj3mAyUH5R",
        authorizationToken: "zzaHo7HsRl5x9NMR",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        // console.log(error);
        setLoading(true)
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <>
      <div className="container containerBoreder " id="aadhaar">
        <h2 className="pageTitle">AadhaAr OCR</h2>
        <div className="row">
            <div className="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div className="col-4">
              <button className="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
        <br />
        <b>Masked Image:</b><br />
        <img
              alt=""
              className="imgBorder"
              src={
                cardData.hasOwnProperty("item.details.aadhaar.masked_value")
                  ? "data:image/png;base64," +
                    cardData["item.details.aadhaar.masked_value"]
                  : ""
              }
            ></img>
        <table className="table">
          <tbody>
          <tr>
              <th>Is Aadhaar Masked: </th>
              <td>
                {cardData.hasOwnProperty("item.details.aadhaar.ismasked")
                  ? "" + cardData["item.details.aadhaar.ismasked"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Aadhaar Number: </th>
              <td>
                {cardData.hasOwnProperty("item.details.aadhaar.value")
                  ? "" + cardData["item.details.aadhaar.value"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Qr Status: </th>
              <td>
                {cardData.hasOwnProperty("item.details.aadhaar.qrstatus")
                  ? "" + cardData["item.details.aadhaar.qrstatus"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th> Address care of:</th>
              <td>
                {cardData.hasOwnProperty("item.details.address.care_of")
                  ? "" + cardData["item.details.address.care_of"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>City: </th>
              <td>
                {cardData.hasOwnProperty("item.details.address.city")
                  ? "" + cardData["item.details.address.city"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>District:</th>
              <td>
                {cardData.hasOwnProperty("item.details.address.district")
                  ? "" + cardData["item.details.address.district"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>House Number:</th>
              <td>
                {cardData.hasOwnProperty("item.details.address.house_number")
                  ? "" + cardData["item.details.address.house_number"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Landmark:</th>
              <td>
                {cardData.hasOwnProperty("item.details.address.landmark")
                  ? "" + cardData["item.details.address.landmark"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Address line1: </th>
              <td>
                {cardData.hasOwnProperty("item.details.address.line1")
                  ? "" + cardData["item.details.address.line1"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Address line2: </th>
              <td>
                {cardData.hasOwnProperty("item.details.address.line2")
                  ? "" + cardData["item.details.address.line2"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Address Pin:</th>
              <td>
                {cardData.hasOwnProperty("item.details.address.pin")
                  ? "" + cardData["item.details.address.pin"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>State:</th>
              <td>
                {cardData.hasOwnProperty("item.details.address.state")
                  ? "" + cardData["item.details.address.state"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Date of birth: </th>
              <td>
                {cardData.hasOwnProperty("item.details.dob")
                  ? "" + cardData["item.details.dob"]
                  : ""}{" "}
              </td>
            </tr>
            <tr>
              <th>Gender: </th>
              <td>
                {cardData.hasOwnProperty("item.details.gender.value")
                  ? "" + cardData["item.details.gender.value"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Husband:</th>
              <td>
                {cardData.hasOwnProperty("item.details.husband.value")
                  ? "" + cardData["item.details.husband.value"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Name:</th>
              <td>
                {cardData.hasOwnProperty("item.details.name.value")
                  ? "" + cardData["item.details.name.value"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Father: </th>
              <td>
                {cardData.hasOwnProperty("item.details.father.value")
                  ? "" + cardData["item.details.father.value"]
                  : ""}
              </td>
            </tr>
            <tr>
              <th>Daughter:</th>
              <td>
                {cardData.hasOwnProperty("item.details.daughter_of.value")
                  ? "" + cardData["item.details.daughter_of.value"]
                  : ""}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default AdharOCR;
